var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        opacity: 0.5;\n      }\n\n      .cls-2, .cls-5 {\n        fill: #fafafa;\n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3, .cls-5 {\n        stroke: #fafafa;\n      }\n\n      .cls-6 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19253",
    "data-name": "Group 19253",
    transform: "translate(13365 20345)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1884",
    "data-name": "Rectangle 1884",
    className: "cls-1",
    width: 22,
    height: 34,
    rx: 11,
    transform: "translate(-13365 -20345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1886",
    "data-name": "Rectangle 1886",
    className: "cls-2",
    d: "M11,0h0a0,0,0,0,1,0,0V15a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V11A11,11,0,0,1,11,0Z",
    transform: "translate(-13365 -20345)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    "data-name": "Group 3492",
    transform: "translate(73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1884-2",
    "data-name": "Rectangle 1884",
    className: "cls-3",
    transform: "translate(-13438 -20345)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 22,
    height: 34,
    rx: 11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 33,
    rx: 10.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1887",
    "data-name": "Rectangle 1887",
    className: "cls-4",
    width: 4,
    height: 8,
    rx: 2,
    transform: "translate(-13429 -20338)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1888",
    "data-name": "Rectangle 1888",
    className: "cls-5",
    transform: "translate(-13356 -20338)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 4,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 7,
    rx: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark-mode.ef374783318db571ce66e058c10b09df.svg";
export { ForwardRef as ReactComponent };